(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-alya-timeline-faq';

  /* ---- Tabs ------------------------------------------------------------- */
  function initTabs(section) {
    var tabs = section.querySelectorAll('.oddit-section-alya-timeline-faq__tab');
    var panels = section.querySelectorAll('.oddit-section-alya-timeline-faq__panel');
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      for (var i = 0; i < tabs.length; i++) {
        var active = i === index;
        tabs[i].classList.toggle('oddit-section-alya-timeline-faq__tab--active', active);
        tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', active ? '0' : '-1');
      }
      for (var j = 0; j < panels.length; j++) {
        var panelActive = j === index;
        panels[j].classList.toggle('oddit-section-alya-timeline-faq__panel--active', panelActive);
        if (panelActive) {
          panels[j].removeAttribute('hidden');
        } else {
          panels[j].setAttribute('hidden', '');
        }
      }
    }

    function onKeydown(e) {
      var current = Number(e.currentTarget.getAttribute('data-tab-index'));
      if (isNaN(current)) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = (current + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = (current - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = tabs.length - 1;
      }
      if (next !== null) {
        e.preventDefault();
        activate(next);
        tabs[next].focus();
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function (e) {
        var index = Number(e.currentTarget.getAttribute('data-tab-index'));
        if (!isNaN(index)) activate(index);
      });
      tabs[k].addEventListener('keydown', onKeydown);
    }
  }

  /* ---- FAQ accordion ---------------------------------------------------- */
  function initFaq(section) {
    var items = section.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    function collapse(item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (answer) answer.setAttribute('aria-hidden', 'true');
    }

    function expand(item) {
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (answer) answer.setAttribute('aria-hidden', 'false');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!trigger || !answer) return;

      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          collapse(item);
          return;
        }
        // Accordion: close any other open item first.
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            collapse(other);
          }
        });
        expand(item);
      });
    });
  }

  function initSection(section) {
    initTabs(section);
    initFaq(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
